'use client';

import { memo } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import './Navbar.css';

import { routes } from '@/features/v2/constants/routes';

import UserMenu from '@/features/v2/shared/Header/components/UserMenu';

import { useAuth } from '@/core/auth/client/AuthProvider';

import SideBar from './sideBar/SideBar';

export interface NavbarProps {
  content: React.ReactNode;
  position: 'end' | 'start' | 'center';
}

const HNavbar = ({
  content,
  position,
}: NavbarProps) => {
  const { session } = useAuth();
  const getPositionClass = () => {
    switch (position) {
      case 'start':
        return 'justify-start';
      case 'center':
        return 'justify-center';
      case 'end':
        return 'justify-end';
      default:
        return 'justify-end';
    }
  };

  return (
    <div className="grid gap-0 max-w-screen">
      <SideBar />
      <nav className="navbar-content">
        <div className="flex items-center">
          {
            session?.user ? (
              <div className=" md:hidden">
                <UserMenu />
              </div>
            ) : (
              <Link href={routes.HOME} className="md:hidden">
                <Image
                  src="/img/logo/MobileLogo.svg"
                  alt="logo"
                  className="h-10 w-12 mt-1.5"
                  width={48}
                  height={40}
                />
              </Link>
            )
          }
          <Link href="/" className="hidden md:block">
            <Image
              src="/img/logo/LogoDesktop.svg"
              alt="logo"
              className="h-12 w-52 mt-1.5"
              width={208}
              height={48}
            />
          </Link>
        </div>

        <div className={`flex items-center ${getPositionClass()}`}>
          {content}
        </div>
      </nav>
    </div>
  );
};

export default memo(HNavbar);
